export default {
  BIRTHDAY:'',
  BIRTHPLACE:'',
  CALC_SUMM:44000,
  CALC_WEEK:52,
  CONST_INCOME:'',
  CREDHISTORY_RADIO:'',
  EMAIL:'',
  EXPER_RADIO:'',
  FIRST_NAME:'',
  GENDER:'F',
  IS_ADDRESS_COINCIDES:'N',
  IS_I_CERTIFY_REGISTRATION:'Y',
  LAST_NAME:'',
  MEETING_DATE:'',
  MEETING_HOUR:'',
  OTHER_SOURCES_OF_INCOME:'',
  PASSPORT_DATE:'',
  PASSPORT_DEP:'',
  PASSPORT_DEP_CODE:'',
  PASSPORT_NUMBER:'',
  PASSPORT_SERIES:'',
  PHONE:'',
  PRODUCT_ID:'S',
  REGISTRATION_ADDRESS:'',
  REGISTRATION_ADDRESS_DADATA:'',
  RESIDENTIAL_ADDRESS:'',
  RESIDENTIAL_ADDRESS_DADATA:'',
  SECOND_NAME:'',
  WORK_JOB:''
}